import { TextInputCell } from './TextInputCell';

export default TextInputCell;
